export type Locale = "fr" | "en";

export type LocalizedAsset = Record<Locale, any>;

export function localizeAsset(locale: "fr" | "en", asset: LocalizedAsset) {
  return asset[locale].default;
}
